import { guidesService } from '@/services/guides.service.js';

const state = {
  getGuidesOutput: null,
  getGuideByIdOutput: null,
  createGuideOutput: null,
  updateGuideOutput: null,
  deleteGuideByIdOutput: null
};

const mutations = {
  setGetGuidesOutput(state, payload) {
    state.getGuidesOutput = payload;
  },
  setGetGuideByIdOutput(state, payload) {
    state.getGuideByIdOutput = payload;
  },
  setCreateGuideOutput(state, payload) {
    state.createGuideOutput = payload;
  },
  setUpdateGuideOutput(state, payload) {
    state.updateGuideOutput = payload;
  },
  setDeleteGuideByIdOutput(state, payload) {
    state.deleteGuideByIdOutput = payload;
  }
};

const actions = {
  async getGuides({ commit }, input) {
    try {
      const response = await guidesService.getList(input);
      commit('setGetGuidesOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching guides list:', error);
      throw error;
    }
  },
  
  async getById({ commit }, id) {
    try {
      const response = await guidesService.getById(id);
      commit('setGetGuideByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching guide by id:', error);
      throw error;
    }
  },
  
  async create({ commit }, data) {
    try {
      const response = await guidesService.create(data);
      commit('setCreateGuideOutput', response);
      return response;
    } catch (error) {
      console.error('Error creating guide:', error);
      throw error;
    }
  },
  
  async update({ commit }, data) {
    try {
      const response = await guidesService.update(data);
      commit('setUpdateGuideOutput', response);
      return response;
    } catch (error) {
      console.error('Error updating guide:', error);
      throw error;
    }
  },
  
  async deleteGuideById({ commit }, id) {
    try {
      const response = await guidesService.delete(id);
      commit('setDeleteGuideByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error deleting guide:', error);
      throw error;
    }
  }
};

const getters = {
  guides: state => state.getGuidesOutput?.data || [],
  guide: state => state.getGuideByIdOutput || null
};

export const guides = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

